// Preparation methods
const preparations = [
  {
    id: 1,
    name: 'Regular',
    price_adjustment: 0.00
  },
  {
    id: 2,
    name: 'Toasted',
    price_adjustment: 0.10
  },
  {
    id: 3,
    name: 'Grilled',
    price_adjustment: 0.10
  }
];

export default preparations;